import { createAction } from "@reduxjs/toolkit";
import { UserActionTypes } from "./userTypes";
import {
  LoginRequestDto,
  LoginResponseDto,
  SendOtpRequestDto,
  SendOtpResponseDto,
  VerifyOtpRequestDto,
  VerifyOtpResponseDto,
  RegisterRequestDto,
  RegisterSuccessDto,
} from "services/api.services/user/userServiceType";

export const loginRequest = createAction<LoginRequestDto>(
  UserActionTypes.LOGIN_REQUEST,
);
export const loginInitiateSuccess = createAction<LoginResponseDto>(
  UserActionTypes.LOGIN_INITIATE_SUCCESS,
);
export const loginSuccess = createAction<VerifyOtpResponseDto>(
  UserActionTypes.LOGIN_SUCCESS,
);
export const loginFailure = createAction<string>(UserActionTypes.LOGIN_FAILURE);

export const sendOtpRequest = createAction<SendOtpRequestDto>(
  UserActionTypes.SEND_OTP_REQUEST,
);
export const sendOtpSuccess = createAction<SendOtpResponseDto>(
  UserActionTypes.SEND_OTP_SUCCESS,
);
export const sendOtpFailure = createAction<string>(
  UserActionTypes.SEND_OTP_FAILURE,
);

export const verifyOtpRequest = createAction<VerifyOtpRequestDto>(
  UserActionTypes.VERIFY_OTP_REQUEST,
);
export const verifyOtpFailure = createAction<string>(
  UserActionTypes.VERIFY_OTP_FAILURE
);

export const logout = createAction(UserActionTypes.LOGOUT);

export const fetchSessionRequest = createAction(
  UserActionTypes.FETCH_SESSION_REQUEST,
);
export const fetchSessionSuccess = createAction<unknown>(
  UserActionTypes.FETCH_SESSION_SUCCESS,
);
export const fetchSessionFailure = createAction<string>(
  UserActionTypes.FETCH_SESSION_FAILURE,
);

export const registerRequest = createAction<RegisterRequestDto>(
  UserActionTypes.REGISTER_REQUEST,
);
export const registerSuccess = createAction<RegisterSuccessDto>(
  UserActionTypes.REGISTER_SUCCESS,
);
export const registerFailure = createAction<string>(
  UserActionTypes.REGISTER_FAILURE,
);

// import { createAction } from "@reduxjs/toolkit";
// import { UserActionTypes } from "./userTypes";
// import { RegisterPayload } from "services/api.services/user/userServiceType";

// export const loginRequest = createAction<{ email: string; password: string }>(
//   UserActionTypes.LOGIN_REQUEST,
// );

// export const loginSuccess = createAction<Record<string, any>>(
//   UserActionTypes.LOGIN_SUCCESS,
// );

// export const loginFailure = createAction<string>(UserActionTypes.LOGIN_FAILURE);

// export const logout = createAction(UserActionTypes.LOGOUT);

// export const fetchSessionRequest = createAction(
//   UserActionTypes.FETCH_SESSION_REQUEST,
// );

// export const fetchSessionSuccess = createAction<Record<string, any>>(
//   UserActionTypes.FETCH_SESSION_SUCCESS,
// );

// export const fetchSessionFailure = createAction<string>(
//   UserActionTypes.FETCH_SESSION_FAILURE,
// );

// // 🔹 Register actions
// export const registerRequest = createAction<RegisterPayload>(
//   UserActionTypes.REGISTER_REQUEST,
// );

// export const registerSuccess = createAction<Record<string, any>>(
//   UserActionTypes.REGISTER_SUCCESS,
// );

// export const registerFailure = createAction<string>(
//   UserActionTypes.REGISTER_FAILURE,
// );
